import React, { useEffect } from 'react';
import "../../assets/styles/Profile.css";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import imgBtnUser from "../../imgs/bt-change-name.png";
import imgBtnUserHover from "../../imgs/bt-change-name-hover.png";
import imgBtnPhone from "../../imgs/bt-change-phone.png";
import imgBtnPhoneHover from "../../imgs/bt-change-phone-hover.png";
import imgBtnMail from "../../imgs/bt-change-mail.png";
import imgBtnMailHover from "../../imgs/bt-change-mail-hover.png";
import imgBtnBank from "../../imgs/bt-change-bank.png";
import imgBtnPassword from "../../imgs/bt-change-password.png";
import imgConfirmInfo from "../../imgs/bt_confirm_info.png";
import imgBtnBankHover from "../../imgs/bt-change-bank-hover.png";
import Collapsible from "react-collapsible";
import imgBottom from "../../imgs/img-bottom-cskh.png";
import imgBtnBirthday from "../../imgs/bt-change-birtday.png";
import imgBtnBirthdayHover from "../../imgs/bt-change-birtday-hover.png";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import RequestHistory from "../../components/Profile/RequestHistory";

import * as yup from 'yup';


function Profile() {
  const location = useLocation();
  const { userName, data, webSetting, sendType, lastBank } = location.state || {};
  const confirmAccountOnly = data?.have_btn_confirm_account === true;
  const navigate = useNavigate();

  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Email is invalid').required('Email is required'),
    phoneNumber: yup.string().matches(/^[0-9]+$/, 'Phone number must be digits').required('Phone number is required'),
  });

  const shouldNavigate =(!userName || userName === "undefined");
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const changeInfo = async (typeModal) => {
      if (!userName) {
        return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
      } else {
        navigate("/change-info",{ state: { ...location.state, data, typeModal, sendType: confirmAccountOnly ? "files" : sendType }, replace: !!lastBank });
      }
    };
    const items = [
      {
        id: "full_name",
        text: "Thay đổi họ và tên chủ tài khoản",
        image: imgBtnUser,
      },
      {
        id: "bank",
        text: "Thay đổi thông tin ngân hàng liên kết",
        image: imgBtnBank,
      },
      {
        id: "phone_number",
        text: "Cập nhật số điện thoại",
        image: imgBtnPhone,
      },
      {
        id: "reset_pass",
        text: "Cấp lại mật khẩu đăng nhập",
        image: imgBtnPassword,
      },
      {
        id: "confirm_account",
        text: "Xác minh tài khoản",
        image: imgConfirmInfo,
      },
    ].filter((item) => confirmAccountOnly ? item.id === "confirm_account" : item.id !== "confirm_account");

    return (
      <div className={`profile container${confirmAccountOnly ? " profile-confirm-only" : ""}`}>
        <motion.div
          // className="app"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 5 }}
          // className="app"
          // initial={{ x: "-100vw", opacity: 0 }}
          // animate={{ x: 0, opacity: 1 }}
          // exit={{ x: "100vw", opacity: 0 }}
          // transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        >
          <Header isPageSearch={false} pageToAcction={confirmAccountOnly ? "/" : "/type-confirm"} data={ {userName, data, webSetting, lastBank} } />
          

          <div className="content">
            <div className="profile">
              <RequestHistory key={userName} account={userName} requests={data?.recent_requests || []} lastBank={lastBank} />
              <span className="profile-titlte">{confirmAccountOnly ? "Vui lòng xác minh tài khoản" : "Vui lòng chọn thông tin bạn cần thay đổi"}</span>
              <div className="grid-container">
                {items.map((item) => (
                  <div
                    key={item.id}
                    className={`grid-item${item.id === "confirm_account" ? " grid-item-confirm-account" : ""}`}
                    onClick={() => changeInfo(item.id)}
                  >
                    <img src={item.image} alt="" className="grid-image" />
                    <div className="grid-text">{item.text}</div>
                  </div>
                ))}
              </div>
              {/* <div className="action">
                <div className="action-btn" onClick={() => changeInfo("full_name")}>
                  <img className="img-default" src={imgBtnUser} alt="icon-user" />
                  <img className="img-hover" src={imgBtnUserHover} alt="icon-user" />
                </div>
                <div className="action-btn" onClick={() => changeInfo("phone_number")}>
                  <img className="img-default" src={imgBtnPhone} alt="icon-phone" />
                  <img className="img-hover" src={imgBtnPhoneHover} alt="icon-user" />
                </div>
              </div>
              <div className="action">
                <div className="action-btn" onClick={() => changeInfo("email")}>
                  <img className="img-default" src={imgBtnMail} alt="icon-mail" />
                  <img className="img-hover" src={imgBtnMailHover} alt="icon-mail" />
                </div>
                <div className="action-btn" onClick={() => changeInfo("bank")}>
                  <img className="img-default" src={imgBtnBank} alt="icon-bank" />
                  <img className="img-hover" src={imgBtnBankHover} alt="icon-bank" />
                </div>
              </div> */}
              {/* <div>
                <img className="img-bottom img-bottom-profile" alt="bottom" src={imgBottom} />
              </div> */}
            </div>
          </div>
        </motion.div>
      </div>
    );
  }
}

export default Profile;
